var REALMS = {
  CUSTOMER: 'customer',
  SPONSOR: 'sponsor',
  ADVISOR: 'advisor',
  MCI: 'mortgagecreditor',
  TRAVEL: 'travel'
};
var HEADER_REALM_KEYS = ['CUSTOMER', 'ADVISOR', 'SPONSOR'];

/**
 * Normalizes a realm a validated safe value
 *
 * @export
 * @param {string} realm The realm to normalize
 * @returns The normalized realm
 */
function normalizeRealm(realm) {
  var normalizedRealm;
  if (!realm) {
    normalizedRealm = REALMS.CUSTOMER;
  } else if (Object.values(REALMS).includes(realm)) {
    normalizedRealm = realm;
  } else {
    normalizedRealm = REALMS.CUSTOMER;
  }
  return normalizedRealm;
}

/**
 * Manage ID uses different realm names than the normal mapping
 * This function maps the normal realms to their Manage ID equivalents
 *
 * @param {string} realm A regularly supported realm
 * @returns The Manage ID equivalent of the realm
 */
function toManageIdRealm(realm) {
  switch (realm) {
    case REALMS.CUSTOMER:
      return 'user';
    case REALMS.ADVISOR:
      return 'advisors';
    default:
      return 'user';
  }
}

/**
 * Returns an array of paths for react-router that include a validated realm param
 *
 * @export
 * @param {*} path The non-realm-specific path
 * @returns An array of paths for react-router that include a realm param
 */
function getRealmAwarePaths(path) {
  var validRealmPaths = Object.values(REALMS).join('|');
  return [path, "/:realm(".concat(validRealmPaths, ")").concat(path)];
}

/**
 * Returns filtered REALMS based on the provided filter list
 *
 * @param {Array} filterList List of Realm keys to be filtered
 * @returns Filtered Realms
 */
function getFilteredRealms(filterList) {
  return Object.keys(REALMS).filter(function (realmKey) {
    return filterList.includes(realmKey);
  }).reduce(function (res, key) {
    res[key] = REALMS[key];
    return res;
  }, {});
}export{HEADER_REALM_KEYS,REALMS,getFilteredRealms,getRealmAwarePaths,normalizeRealm,toManageIdRealm};